/* Lepinceau rebuild: header behaviour (sections/lp-header.liquid).
   Mega panels, compact sticky state, predictive search, mobile drawer, cart count. */
(function () {
  'use strict';

  var header = document.getElementById('lp-header');
  if (!header) return;

  var root = document.documentElement;
  var wrap = header.closest('.shopify-section') || header.parentElement;
  var announce = document.getElementById('lp-announce');
  var config = window.lpHeader || {};

  /* ---------- Sticky: the announcement bar scrolls away, the header turns compact ---------- */

  function announceHeight() {
    return announce ? announce.offsetHeight : 0;
  }

  function setOffset() {
    wrap.style.setProperty('--lp-announce-h', announceHeight() + 'px');
  }

  var ticking = false;
  function onScroll() {
    ticking = false;
    header.classList.toggle('is-scrolled', window.scrollY > announceHeight() + 8);
  }

  setOffset();
  onScroll();
  window.addEventListener('resize', setOffset);
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, { passive: true });

  /* ---------- Mega panels ---------- */

  var items = Array.prototype.slice.call(header.querySelectorAll('.lp-nav__item--panel'));
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openItem = null;
  var openedAt = 0;
  var openTimer;
  var closeTimer;

  function openPanel(item) {
    if (openItem && openItem !== item) closePanel(openItem);
    closeSearch();
    item.classList.add('is-open');
    item.querySelector('.lp-nav__link').setAttribute('aria-expanded', 'true');
    openItem = item;
    openedAt = Date.now();
  }

  function closePanel(item) {
    if (!item) return;
    item.classList.remove('is-open');
    item.querySelector('.lp-nav__link').setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }

  items.forEach(function (item) {
    var button = item.querySelector('.lp-nav__link');

    button.addEventListener('click', function () {
      // A hover just opened it: the click that follows should not close it again.
      if (item.classList.contains('is-open') && Date.now() - openedAt > 350) {
        closePanel(item);
      } else {
        openPanel(item);
      }
    });

    item.addEventListener('mouseenter', function () {
      if (!finePointer.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(item); }, openItem ? 0 : 110);
    });

    item.addEventListener('mouseleave', function () {
      if (!finePointer.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { closePanel(item); }, 180);
    });

    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) closePanel(item);
    });
  });

  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) closePanel(openItem);
  });

  /* ---------- Search ---------- */

  var search = document.getElementById('lp-search');
  var searchInput = search && search.querySelector('.lp-search__input');
  var suggestBox = search && search.querySelector('[data-lp-search-suggest]');
  var resultsBox = search && search.querySelector('[data-lp-search-results]');
  var searchTriggers = Array.prototype.slice.call(header.querySelectorAll('[data-lp-search-open]'));
  var searchTimer;
  var searchAbort;
  var lastTrigger;

  function setTriggers(expanded) {
    searchTriggers.forEach(function (t) { t.setAttribute('aria-expanded', expanded ? 'true' : 'false'); });
  }

  function openSearch(trigger) {
    if (!search) return;
    lastTrigger = trigger || null;
    if (openItem) closePanel(openItem);
    search.hidden = false;
    requestAnimationFrame(function () { search.classList.add('is-open'); });
    setTriggers(true);
    setTimeout(function () { searchInput && searchInput.focus(); }, 30);
  }

  function closeSearch(returnFocus) {
    if (!search || search.hidden) return;
    search.classList.remove('is-open');
    setTriggers(false);
    setTimeout(function () { search.hidden = true; }, 240);
    if (returnFocus && lastTrigger) lastTrigger.focus();
  }

  searchTriggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.stopPropagation();
      if (search.hidden) openSearch(t);
      else closeSearch(true);
    });
  });

  var closeBtn = search && search.querySelector('[data-lp-search-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { closeSearch(true); });

  document.addEventListener('click', function (e) {
    if (search && !search.hidden && !search.contains(e.target)) closeSearch();
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(price) {
    var format = config.moneyFormat || '{{amount}}';
    var number = parseFloat(price);
    if (isNaN(number)) return '';
    var fixed = number.toFixed(2).replace(/\.00$/, '');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      return key.indexOf('comma') > -1 ? fixed.replace('.', ',') : fixed;
    }).replace(/<[^>]*>/g, '');
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function renderResults(query, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [];
    var collections = res.collections || [];
    var allUrl = (config.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(query);
    var html = '';

    if (!products.length && !collections.length) {
      html = '<p class="lp-search__empty">Aucun tableau ne correspond à « ' + escapeHtml(query) + ' ». Essayez un thème, une couleur ou une pièce.</p>';
    } else {
      html += '<div><p class="lp-search__label">Tableaux</p><ul class="lp-search__products" role="list">';
      products.forEach(function (p) {
        html += '<li><a class="lp-search__product" href="' + escapeHtml(p.url) + '">' +
          (p.image ? '<img src="' + escapeHtml(sized(p.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<img alt="">') +
          '<span><span class="lp-search__product-title">' + escapeHtml(p.title) + '</span>' +
          '<span class="lp-search__product-price">' + escapeHtml(formatMoney(p.price)) + '</span></span></a></li>';
      });
      html += '</ul></div>';
      html += '<div>';
      if (collections.length) {
        html += '<p class="lp-search__label">Collections</p><ul class="lp-search__cols" role="list">';
        collections.forEach(function (c) {
          html += '<li><a href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
        });
        html += '</ul>';
      }
      html += '</div>';
    }
    html += '<div class="lp-search__foot"><a class="lp-btn lp-btn--pill lp-btn--dark" href="' + escapeHtml(allUrl) + '">Voir tous les résultats</a></div>';

    resultsBox.innerHTML = html;
    resultsBox.hidden = false;
    if (suggestBox) suggestBox.hidden = true;
  }

  function runSearch() {
    var query = searchInput.value.trim();
    if (query.length < 2) {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      if (suggestBox) suggestBox.hidden = false;
      return;
    }
    if (searchAbort) searchAbort.abort();
    searchAbort = 'AbortController' in window ? new AbortController() : null;
    var url = (config.suggestUrl || '/search/suggest.json') +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin', signal: searchAbort ? searchAbort.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(query, data); })
      .catch(function () {});
  }

  if (searchInput && resultsBox) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(runSearch, 220);
    });
  }

  /* ---------- Drawer (mobile) ---------- */

  var drawer = document.getElementById('lp-drawer');
  var scrim = document.querySelector('[data-lp-scrim]');
  var burger = header.querySelector('[data-lp-drawer-open]');

  function openDrawer() {
    if (!drawer) return;
    closeSearch();
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    root.classList.add('lp-lock');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
    });
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var close = drawer.querySelector('[data-lp-drawer-close]');
    setTimeout(function () { close && close.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    root.classList.remove('lp-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      drawer.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 320);
    if (burger) burger.focus();
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelector('[data-lp-drawer-close]').addEventListener('click', closeDrawer);
    // Keep focus inside the open drawer.
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = drawer.querySelectorAll('a[href], button, input, summary');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  if (scrim) scrim.addEventListener('click', closeDrawer);

  window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
    if (mq.matches) closeDrawer();
  });

  /* ---------- Escape closes whatever is open ---------- */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) { closeDrawer(); return; }
    if (search && !search.hidden) { closeSearch(true); return; }
    if (openItem) {
      var button = openItem.querySelector('.lp-nav__link');
      closePanel(openItem);
      button.focus();
    }
  });

  /* ---------- Cart count ----------
     Refreshes after any cart request (the theme's AJAX add-to-cart included) and when a
     page comes back from the back/forward cache. */

  var counters = Array.prototype.slice.call(document.querySelectorAll('[data-lp-cart-count]'));

  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        var hit = list.getEntries().some(function (entry) {
          return /\/cart\/(add|change|update|clear)/.test(entry.name);
        });
        if (hit) setTimeout(refreshCart, 60);
      }).observe({ type: 'resource' });
    } catch (err) {}
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCart();
  });

  /* ---------------------------------------------------------------
     Favourites count on the header heart.
     The hearts on product cards are the legacy Wokiee wishlist: a JSON
     map (product id -> URL) kept in localStorage under "wokiee_wishlist",
     per browser. We only read it; Wokiee still owns adding and removing.
     --------------------------------------------------------------- */
  var WISH_STORE = 'wokiee_wishlist';
  var wishCounts = document.querySelectorAll('[data-lp-wish-count]');
  var wishLinks = document.querySelectorAll('[data-lp-wish-link]');

  function wishTotal() {
    try {
      var raw = window.localStorage.getItem(WISH_STORE);
      var data = raw ? JSON.parse(raw) : null;
      return data && typeof data === 'object' ? Object.keys(data).length : 0;
    } catch (err) {
      return 0;
    }
  }

  function refreshWish() {
    var n = wishTotal();
    [].forEach.call(wishCounts, function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    [].forEach.call(wishLinks, function (el) {
      el.classList.toggle('has-items', n > 0);
    });
  }

  if (wishCounts.length) {
    refreshWish();
    /* Wokiee writes to localStorage in its own click handler on body; read after it. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.wlbutton-js')) setTimeout(refreshWish, 80);
    });
    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === WISH_STORE) refreshWish();
    });
    window.addEventListener('pageshow', refreshWish);
  }
})();
